import { reducerWithInitialState } from "typescript-fsa-reducers";
import {SideMenuStateInitialState, deepCopySideMenuState } from "../typing/side_menu_state";
import {setSideMenuDropdownIsOpen, setSideMenuEntry, setSideMenuCollapse} from "../actions/side_menu_actions";

export default  reducerWithInitialState(SideMenuStateInitialState)
    .case(setSideMenuDropdownIsOpen, (state, payload) => { 
        const deepCopy = deepCopySideMenuState(state);
        deepCopy.isDropdownOpen = payload.isopen;
        return deepCopy; 
    })
    .case(setSideMenuEntry, (state, payload) => {
        const deepCopy = deepCopySideMenuState(state);
        deepCopy.selectedMenuPoint = payload.nextentry;
        return deepCopy;
    })
    .case(setSideMenuCollapse, (state, payload) => {
        const deepCopy = deepCopySideMenuState(state);
        deepCopy.collapsed = payload.collapsed;
        return deepCopy;
    });

    